/**
 * SoleadLab 2.0 - Thermal Stats
 *
 * Displays temperature measurements for ROIs and points
 * in a monospace list.
 *
 * REFERENCE: editor (23).html _renderList (line 7533-7544)
 */

import type { ThermalRoi, ThermalPoint } from './thermalTypes';
import './ThermalStats.css';

interface ThermalStatsProps {
  rois: ThermalRoi[];
  points: ThermalPoint[];
}

export default function ThermalStats({ rois, points }: ThermalStatsProps) {
  if (rois.length === 0 && points.length === 0) return null;

  return (
    <div className="thermal-stats">
      {rois.map((r, i) => {
        if (r.stats) {
          return (
            <div key={`roi-${i}`} className="thermal-stats__roi-block">
              <div className="thermal-stats__line">
                <span className="thermal-stats__label">ROI{i + 1}:</span>
                {' '}max {r.stats.max_c.toFixed(2)}°C
                {' · '}avg {r.stats.avg_c.toFixed(2)}°C
                {' · '}min {r.stats.min_c.toFixed(2)}°C
              </div>
              {r.stats.delta_t > 0 && (
                <div className="thermal-stats__line thermal-stats__line--delta">
                  <span className="thermal-stats__delta">
                    ΔT {r.stats.delta_t.toFixed(2)}°C
                  </span>
                  {' '}(ref {r.stats.ref_c.toFixed(2)}°C)
                </div>
              )}
            </div>
          );
        }
        return (
          <div key={`roi-${i}`} className="thermal-stats__line thermal-stats__line--pending">
            ROI{i + 1}: (no stats)
          </div>
        );
      })}
      {points.map((p, i) => (
        <div key={`pt-${i}`} className="thermal-stats__line">
          <span className="thermal-stats__label">P{i + 1}:</span>
          {' '}
          {p.value_c != null
            ? `${p.value_c.toFixed(2)}°C`
            : '(no value)'}
        </div>
      ))}
    </div>
  );
}
